import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function H2Icon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M2.26367 18H4.55167V13.36H9.25567V18H11.5597V6.56H9.25567V11.136H4.55167V6.56H2.26367V18Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13.5478 18H21.3078V16.192H16.2038C16.3958 15.648 17.3078 14.832 18.3158 14.096C19.6918 13.168 21.1798 12.064 21.1798 9.92C21.1798 7.792 19.5318 6.64 17.4678 6.64C14.9078 6.64 13.4838 8.08 13.5318 10.64H15.5478C15.5478 9.376 16.0118 8.464 17.3398 8.464C18.4118 8.464 19.0838 9.008 19.0838 10.08C19.0838 11.392 17.8838 12.208 16.8278 12.928C14.8118 14.4 13.5478 15.536 13.5478 18Z",
    fill: "currentColor"
  }));
}